<template>

    <div class="author" :class="{'author_center' : isCenter}">
        <div class="author_card" :class="{'author_card_anchor' : hasAnchor}" @click="anchorGoto">
            <div v-if="image" class="author_card_image">
                <img :src="imgPath(image)"  />
            </div>
            <div class="author_card_content">
                <div class="author_card_content_name">{{ name }}</div>
                <div class="author_card_content_title">{{ title }}</div>
            </div>
        </div>
        <div v-if="quote" class="author_quote">
            {{ quote }}
        </div>
    </div>

</template>

<script>
    import $ from 'jquery';
    import top from 'jquery';
    import ArticleSection from "./ArticleSection";
    export default {
        name: 'Author',
        components: {ArticleSection},
        props: ['image', 'name', 'title', 'quote', 'centered','anchor'],
        data: function(){
            return {
                isCenter: false,
                hasAnchor: false,
            };
        },
        methods: {
            imgPath: function(image){
                return require('../assets/img/'+image);
            },
            anchorGoto: function() {
                if(this.anchor){
                    this.$events.fire('page-unlockScroll');
                    let hash = this.anchor;
                    let target_anchor = $("#" + this.anchor);
                    let offset_anchor = $(target_anchor).offset().top;

                    $('.pageSelector .page').animate({
                        scrollTop: offset_anchor
                    }, 500, function(){
                        ////console.log(hash);
                    });
                }

            },
        },
        mounted: function(){

            if(this.centered == 'center'){
                this.isCenter = true;
            }

            if(this.anchor){
                this.hasAnchor = true;
            }
        },
    };
</script>

<style scoped lang="scss">
    .author{

        &_card {
            display: flex;
            align-items: center;

            &_anchor {
                cursor: pointer;
            }

            &_image{
                width: 14rem;
                min-width: 14rem;
                height: 14rem;
                object-fit: cover;
                margin-right: $G-default/1.2;
                img{
                    width: 100%;
                    height: 100%;
                    border-radius: 10rem;
                }
            }
            &_content{
                font-family: $F-Montserrat;
                font-size: 2rem;
                line-height: 1.5em;
                text-transform: uppercase;
                font-weight: $FW-semibold;

                &_title{
                    font-size:1.3rem;
                    line-height:1.5em;
                    max-width: 50rem;
                    margin: auto;
                }

            }
        }
            
        &_quote{
            margin-top: $G-default/1.5;
            font-weight: $FW-normal;
        }

        &.author_center{
            
            .author_card {
                text-align: center;
                display: block;

                .author_card_image {
                    margin: 0 auto 2rem auto;
                }
            }
        }
    }


</style>